/**
 * Footer Component
 *
 * Footer bar for the admin panel.
 * Displays copyright and version information.
 *
 * @component
 */

import React from 'react';
import './Footer.css';

/**
 * Footer component
 */
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-text">
          {currentYear} Bingo Admin Panel - Gana el Pote. Todos los derechos reservados.
        </p>
        <p className="footer-version">v1.0.0</p>
      </div>
    </footer>
  );
};

export default Footer;
